import { Col, NewDateInput, Row, TextInput } from '@digitools/honest-react';
import React from 'react';
import { optionalFieldCharacters } from 'src/utils/validationUtils';
/*                       *
**   About the Accident **
*                       */
const AccidentInformation = ({ claimant, event }) => {
    return (<Row>
      <Col xl={4} md={6} sm={12}>
        <NewDateInput data-testid='policyInfo_dateOfAccident' field={'policyInfo_dateOfAccident'} label={'Date of accident (optional)'} ariaLabelText={'Date of accident'} required={false}/>
      </Col>
      {claimant === 'dependent' && (<Col xl={4} md={6} sm={12}>
          <TextInput data-testid='policyInfo_accidentLocation' field={'policyInfo_accidentLocation'} ariaLabelText={'Location of accident'} label={'Location of accident (optional)'} mask={optionalFieldCharacters} type={'text'}/>
        </Col>)}
      <Col xl={4} md={6} sm={12}>
        <TextInput data-testid='policyInfo_briefAboutAccident' field={'policyInfo_briefAboutAccident'} ariaLabelText={'Brief description of accident'} label={'Brief description of accident (optional)'} mask={optionalFieldCharacters} type={'text'}/>
      </Col>
    </Row>);
};
export default AccidentInformation;
